import { render, staticRenderFns } from "./form-display-mode.vue?vue&type=template&id=08502217"
import script from "./form-display-mode.vue?vue&type=script&lang=js"
export * from "./form-display-mode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports